import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { IPagination } from './IPagination.model';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule, NgbPaginationModule, FontAwesomeModule],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  @Input() totalElements: number;
  @Input() pageSize: number;
  @Input() pageNumber: number;
  @Output() onPageChanged: EventEmitter<IPagination> = new EventEmitter();

  changePage(pageSelected: number) {
    if (this.pageNumber === pageSelected - 1) return;
    this.onPageChanged.emit({
      pageSize: this.pageSize,
      pageIndex: pageSelected - 1,
    });
  }
}
